import { render, staticRenderFns } from "./ResultHero.vue?vue&type=template&id=9b4d6a4e&scoped=true&"
import script from "./ResultHero.vue?vue&type=script&lang=js&"
export * from "./ResultHero.vue?vue&type=script&lang=js&"
import style0 from "./ResultHero.vue?vue&type=style&index=0&id=9b4d6a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4d6a4e",
  null
  
)

export default component.exports